import { FC, HTMLProps } from 'react';

type StatusTypes = 'red' | 'green' | string;

interface Props extends HTMLProps<SVGSVGElement> {
  income?: StatusTypes;
  outcome?: StatusTypes;
}

export const StatusIcon: FC<Props> = (props) => {
  const { income, outcome, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      {...other}
    >
      <rect x="1" y="1" width="20.79" height="20.79" rx="3.56" fill="white" />
      <path
        d="M9.04725 6.2134L8.02587 6.21847L7.91108 6.24126C7.69076 6.28515 7.50421 6.34762 7.31682 6.43794C6.61789 6.77643 6.1435 7.42049 6.01941 8.19876L6 8.32031L6.00169 11.5702C6.00253 13.7412 6.00591 14.858 6.01182 14.934C6.03208 15.1914 6.14519 15.5493 6.28953 15.8076C6.37563 15.9629 6.50056 16.1351 6.62127 16.266L6.66854 16.3166L7.94906 15.0361L9.22874 13.7564V11.6014V9.44721H11.3829H13.5379L14.8218 8.16331L16.1057 6.87941L16.0542 6.8313C15.7934 6.58988 15.4414 6.39151 15.1021 6.29528C14.9797 6.25983 14.8261 6.23029 14.7197 6.22185C14.6024 6.21172 10.6604 6.20581 9.04725 6.2134Z"
        fill={income === 'red' ? '#FF6262' : '#48927D'}
      />
      <path
        d="M14.9341 8.50771L13.5591 9.88108V11.8251V13.7691H11.6151H9.67022L8.29769 15.1441C7.54221 15.9005 6.92432 16.5243 6.92432 16.531C6.92432 16.5437 7.05769 16.6323 7.19274 16.71C7.41559 16.8366 7.67136 16.9269 7.95414 16.9784L8.05965 16.9978L11.1491 17.0003C12.9673 17.0012 14.3567 16.9987 14.5256 16.9944C14.7982 16.9868 14.8185 16.9851 14.9265 16.9607C15.2659 16.8847 15.5005 16.7859 15.7706 16.6045C15.904 16.515 15.9918 16.4424 16.1074 16.3276C16.2948 16.141 16.4341 15.946 16.5514 15.7063C16.6595 15.4868 16.7177 15.3121 16.765 15.0648L16.787 14.9466L16.7895 11.9044C16.7912 10.2018 16.7886 8.71536 16.7844 8.52797C16.7768 8.21649 16.7751 8.18694 16.7549 8.0924C16.7068 7.87209 16.6392 7.67288 16.554 7.50237C16.4831 7.3614 16.3379 7.13433 16.3176 7.13433C16.3126 7.13433 15.6896 7.75222 14.9341 8.50771Z"
        fill={outcome === 'red' ? '#FF6262' : '#48927D'}
      />
    </svg>
  );
};
